import { HttpErrorResponse } from '@angular/common/http';
import * as Sentry from '@sentry/angular';

export const sendErrorToSentry = (error: unknown): void => {
  if (error instanceof HttpErrorResponse) {
    const sentryError = new Error(
      `HTTP ${error.status}: ${error.url ?? 'unknown url'}`,
    );
    sentryError.name = 'HttpErrorResponse';
    Sentry.captureException(sentryError, {
      extra: {
        status: error.status,
        url: error.url,
        error: error.error,
        message: error.message,
        responseType: error.responseType,
      },
    });
    return;
  }

  Sentry.captureException(error);
};
